// extracted by mini-css-extract-plugin
export default {"wrapper":"PlXyRgTHNHf8biRO6QhNWA==","content":"_69X7gP7hy17jk8iS2-vIDw=="};